module.exports = __webpack_public_path__ + "static/img/5.458c23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/5.png
// module id = +I8+
// module chunks = 10